import { FC } from "react";
import styles from "./CourseProgressBar.module.scss";

type ProgressBarProps = React.HTMLProps<HTMLProgressElement>

const CourseProgressBar:FC<ProgressBarProps> = (props) => (
  <progress
    className={styles.progressBar}
    {...props}
  />
)

export default CourseProgressBar;